<div class="alert alert-info d-flex flex-row align-items-center">
  <div class="flex-grow-1 text-center">
    <p class="mb-3">{{ 'recuadro-justino.alerta-mensaje' | translate }}</p>
    <button class="btn btn-dark" (click)="redirectToJustino()">
      {{ 'recuadro-justino.alerta-btn' | translate }}
    </button>
  </div>
  <div class="ms-3 d-none d-md-block">
    <img src="assets/img/justino-mini-face.svg" alt="Justino" style="height: 80px" />
  </div>
</div>